import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import { store, persistor } from "./reducers/store";
import { PersistGate } from "redux-persist/integration/react";
import * as serviceWorker from "./registerServiceWorker";

declare global {
  interface Window {
    server: any;
  }
}

const rootEl = document.getElementById("root");
ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  rootEl
);

// disabled PWA service workers to remove caching issues
serviceWorker.unregister();
